export enum BranchesNearYouDataTestidEnum {
  BRANCHES_LOCATION_BUTTON = 'branches-location-button',
  BRANCHES_LIST = 'branches-list',
  BRANCHES_LIST_LINK = 'branches-list-link',
  BRANCHES_LIST_SCHEDULE_BUTTON = 'branches-list-schedule-button',
  BRANCHES_LIST_DETAILS_BUTTON = 'branches-list-details-button',
  BRANCHES_SHOW_MORE_BUTTON = 'branches-show-more-button',
}
